import React, { useState, useEffect } from "react";
import Authenticated from "@/Layouts/Authenticated";
import { Inertia } from "@inertiajs/inertia";
import { InertiaLink, Link, useForm, usePage } from "@inertiajs/inertia-react";
import axios from "axios";
import WorkorderCommentBox from "@/Components/WorkorderCommentBox";
import ImageBox from "@/Components/ImageBox";
import { DateTime } from "luxon";

const SingleWorkorder = (props) => {
  console.log("singleworkorker", props);
  const { data, setData, errors, put, processing } = useForm({
    id: props[0].id,
    workorder_id: props[0].id,
  });
  const handleDelete = () => {
    if (confirm("do you really want to delete this workorder?")) {
      Inertia.delete(route("workorder.destroy", data));
    }
  };
  return (
    <Authenticated
      auth={props.auth}
      errors={props.errors}
      header={
        <div className="card-header fs-3 p-2 border"> {props[0].task}</div>
      }
    >
      <div>
        <div className="card p-3">
          <InertiaLink href={route("workorder.index")}>
            <div className="card-body">
              <span>{props[0].desc}</span>
            </div>
          </InertiaLink>
          <div className="card-text p-3">
            <p>Priority: {props[0].priority}</p>
            <p>Status: {props[0].status}</p>
            <p>Assigned to: {props[0].assigned_to}</p>
            <p>
              Created on: {DateTime.fromISO(props[0].created_at).toRelative()}
            </p>
          </div>
          <div className="d-flex justify-content-around mb-2 pt-3">
            <Link
              className="btn btn-outline-warning"
              href={route("workorder.edit", props[0].id)}
            >
              Edit
            </Link>
            {props.auth.user.id === props[0].user_id ? (
              <button
                className="btn btn-outline-warning"
                onClick={handleDelete}
              >
                Delete
              </button>
            ) : (
              <div></div>
            )}
          </div>
          <WorkorderCommentBox props={data} />
          <ImageBox props={data} />
          <h3>Comments:</h3>
          <ul className="list-group list-group flush">
            {props[1].map((c, i) => {
              return (
                <li key={c.id} className="list-group-item">
                  {c.text}
                </li>
              );
            })}
          </ul>
          <div className="row row-cols-1 row-cols-md-2 g-4">
            {props[2].map((i) => {
              return (
                <div key={i.id} className="col">
                  <div className="card">
                    <a
                      href={`/storage/workorder_images/${i.workorder_image}`}
                      target="_blank"
                    >
                      <img
                        className="card-img-top img-fluid"
                        src={`/storage/workorder_images/${i.workorder_image}`}
                        style={{ maxHeight: "100px", maxWidth: "100px" }}
                      />
                    </a>
                    <div className="card-footer">
                      <small className="text-muted">
                        Created on: {i.created_at}
                      </small>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Authenticated>
  );
};

export default SingleWorkorder;
